var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 61,
    viewBox: "0 0 45 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9688 38.5957H1.65625C1.32812 38.5957 1 38.377 1 37.9395V33.3457C1 27.4395 5.8125 22.627 11.6094 22.627H15.7656C15.9844 22.627 16.2031 22.7363 16.3125 22.9551H23.3125C23.4219 22.7363 23.6406 22.627 23.9688 22.627H28.0156C33.9219 22.627 38.625 27.4395 38.625 33.3457V37.9395C38.625 38.377 38.4062 38.5957 37.9688 38.5957Z",
    fill: "url(#paint0_linear_245_93665)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2965 30.6113C38.5152 31.4863 38.6246 32.3613 38.6246 33.3457V35.5332H36.5996C35.1777 35.5332 34.084 34.4395 34.084 33.127C34.084 31.7051 35.1777 30.6113 36.5996 30.6113H38.2965Z",
    fill: "#5D70D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32852 30.6113C1.10977 31.4863 1.00039 32.3613 1.00039 33.3457V35.5332H3.02539C4.44727 35.5332 5.54102 34.4395 5.54102 33.127C5.54102 31.7051 4.44727 30.6113 3.02539 30.6113H1.32852Z",
    fill: "#5D70D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0938 20.002L23.3125 19.6738C23.3125 19.3457 23.5312 19.0176 23.9688 19.0176C24.2969 19.0176 24.625 19.3457 24.625 19.6738V23.2832V23.3926H24.5156C24.5156 23.502 24.5156 23.6113 24.4062 23.7207L20.5781 29.1895C20.4688 29.4082 20.25 29.5176 20.0312 29.5176C19.8125 29.5176 19.5938 29.4082 19.4844 29.2988L15.2188 23.7207C15.1094 23.6113 15.1094 23.3926 15.1094 23.2832V19.6738C15.1094 19.3457 15.3281 19.0176 15.7656 19.0176C16.0938 19.0176 16.4219 19.3457 16.4219 19.6738L16.6406 20.002C17.7344 20.5488 18.6094 20.3301 19.8125 20.3301C21.0156 20.3301 22 20.5488 23.0938 20.002Z",
    fill: "#302F57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8125 21.752C17.9531 21.752 16.2031 20.9863 14.8906 19.7832C13.6875 18.6895 12.9219 17.2676 12.5938 15.627H12.1562C11.8281 15.627 11.5 15.2988 11.5 14.9707V11.7988C11.5 11.4707 11.8281 11.1426 12.1562 11.1426H12.375C12.375 10.377 12.375 9.50195 12.375 8.62695C12.375 8.29883 12.7031 7.9707 13.0312 7.9707H26.5938C27.0312 7.9707 27.25 8.29883 27.25 8.62695V11.1426H27.4688C27.9062 11.1426 28.125 11.4707 28.125 11.7988V14.9707C28.125 15.2988 27.9062 15.627 27.4688 15.627H27.0312C26.8125 17.2676 26.0469 18.6895 24.8438 19.7832C23.4219 20.9863 21.6719 21.752 19.8125 21.752Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9219 9.39258H12.7031C12.4844 9.39258 12.375 9.2832 12.1562 9.06445L9.53125 5.45508C9.42188 5.3457 9.42188 5.12695 9.42188 4.9082C9.53125 4.68945 9.64062 4.58008 9.85938 4.4707L19.5938 0.533203C19.7031 0.423828 19.9219 0.423828 20.0312 0.533203L29.875 4.58008C30.0938 4.58008 30.2031 4.79883 30.2031 5.01758C30.3125 5.23633 30.2031 5.3457 30.0938 5.56445L27.4688 9.06445C27.3594 9.2832 27.1406 9.39258 26.9219 9.39258Z",
    fill: "#323FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9219 9.39258H12.7031C12.4844 9.39258 12.375 9.2832 12.1562 9.06445L9.53125 5.45508C9.42188 5.3457 9.42188 5.12695 9.42188 4.9082C9.53125 4.68945 9.64062 4.58008 9.85938 4.4707L19.5938 0.533203C19.7031 0.423828 19.9219 0.423828 20.0312 0.533203L29.875 4.58008C30.0938 4.58008 30.2031 4.79883 30.2031 5.01758C30.3125 5.23633 30.2031 5.3457 30.0938 5.56445L27.4688 9.06445C27.3594 9.2832 27.1406 9.39258 26.9219 9.39258Z",
    fill: "url(#paint1_linear_245_93665)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4688 33.8896H19.1562C18.8281 33.8896 18.5 33.5615 18.5 33.2334C18.5 32.9053 18.8281 32.5771 19.1562 32.5771H20.4688C20.7969 32.5771 21.125 32.9053 21.125 33.2334C21.125 33.5615 20.7969 33.8896 20.4688 33.8896Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4688 36.7363H19.1562C18.8281 36.7363 18.5 36.5176 18.5 36.0801C18.5 35.752 18.8281 35.4238 19.1562 35.4238H20.4688C20.7969 35.4238 21.125 35.752 21.125 36.0801C21.125 36.5176 20.7969 36.7363 20.4688 36.7363Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_93665)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_245_93665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0337 30.0849V35.9799C41.0337 36.3865 40.6157 36.4182 40.4003 36.4182C39.9509 36.4143 39.5094 36.537 39.1264 36.7722C38.7434 37.0074 38.4342 37.3456 38.2343 37.7482L37.601 38.9895L36.119 39.2049C35.6763 39.2672 35.26 39.4528 34.9178 39.7405C34.5756 40.0282 34.3213 40.4065 34.1839 40.8319C34.0464 41.2574 34.0315 41.7129 34.1408 42.1464C34.25 42.58 34.4791 42.974 34.8017 43.2835L35.853 44.2842L35.7263 44.9935C35.707 45.0745 35.6615 45.1469 35.597 45.1995C35.5324 45.2522 35.4524 45.2821 35.3691 45.2849H25.8337C25.3175 45.3585 24.7913 45.311 24.2966 45.1461C23.802 44.9811 23.3526 44.7033 22.9839 44.3346C22.6152 43.966 22.3374 43.5165 22.1725 43.0219C22.0076 42.5273 21.96 42.001 22.0337 41.4848V26.2849C21.96 25.7687 22.0076 25.2424 22.1725 24.7478C22.3374 24.2532 22.6152 23.8037 22.9839 23.4351C23.3526 23.0664 23.802 22.7886 24.2966 22.6236C24.7913 22.4587 25.3175 22.4112 25.8337 22.4849H33.4337V26.2849C33.36 26.801 33.4076 27.3273 33.5725 27.8219C33.7374 28.3165 34.0152 28.766 34.3839 29.1346C34.7526 29.5033 35.202 29.7811 35.6966 29.9461C36.1913 30.111 36.7175 30.1585 37.2337 30.0849H41.0337Z",
    fill: "#D9D9D9",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.2341 30.0854H41.0341L33.4341 22.4854V26.2854C33.3604 26.8015 33.4079 27.3278 33.5729 27.8224C33.7378 28.317 34.0156 28.7665 34.3843 29.1351C34.753 29.5038 35.2024 29.7816 35.697 29.9466C36.1917 30.1115 36.7179 30.159 37.2341 30.0854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0504 33.8846C28.0504 34.0725 27.9947 34.2561 27.8903 34.4124C27.7859 34.5686 27.6375 34.6904 27.4639 34.7623C27.2904 34.8342 27.0993 34.853 26.9151 34.8163C26.7308 34.7797 26.5615 34.6892 26.4286 34.5563C26.2958 34.4235 26.2053 34.2542 26.1686 34.0699C26.132 33.8856 26.1508 33.6946 26.2227 33.521C26.2946 33.3474 26.4164 33.1991 26.5726 33.0947C26.7288 32.9903 26.9125 32.9346 27.1004 32.9346C27.3523 32.9346 27.594 33.0347 27.7721 33.2128C27.9503 33.391 28.0504 33.6326 28.0504 33.8846ZM27.1004 38.0012C26.9125 38.0012 26.7288 38.057 26.5726 38.1613C26.4164 38.2657 26.2946 38.4141 26.2227 38.5877C26.1508 38.7613 26.132 38.9523 26.1686 39.1366C26.2053 39.3209 26.2958 39.4901 26.4286 39.623C26.5615 39.7558 26.7308 39.8463 26.9151 39.883C27.0993 39.9196 27.2904 39.9008 27.4639 39.8289C27.6375 39.757 27.7859 39.6353 27.8903 39.479C27.9947 39.3228 28.0504 39.1391 28.0504 38.9512C28.0504 38.6993 27.9503 38.4576 27.7721 38.2795C27.594 38.1013 27.3523 38.0012 27.1004 38.0012ZM36.9171 33.8846C36.9171 33.6326 36.817 33.391 36.6388 33.2128C36.4606 33.0347 36.219 32.9346 35.9671 32.9346H30.2671C30.0151 32.9346 29.7735 33.0347 29.5953 33.2128C29.4171 33.391 29.3171 33.6326 29.3171 33.8846C29.3171 34.1365 29.4171 34.3782 29.5953 34.5563C29.7735 34.7345 30.0151 34.8346 30.2671 34.8346H35.9671C36.219 34.8346 36.4606 34.7345 36.6388 34.5563C36.817 34.3782 36.9171 34.1365 36.9171 33.8846ZM33.1171 38.9512C33.1171 38.6993 33.017 38.4576 32.8388 38.2795C32.6606 38.1013 32.419 38.0012 32.1671 38.0012H30.2671C30.0151 38.0012 29.7735 38.1013 29.5953 38.2795C29.4171 38.4576 29.3171 38.6993 29.3171 38.9512C29.3171 39.2032 29.4171 39.4448 29.5953 39.623C29.7735 39.8011 30.0151 39.9012 30.2671 39.9012H32.1671C32.419 39.9012 32.6606 39.8011 32.8388 39.623C33.017 39.4448 33.1171 39.2032 33.1171 38.9512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8756 38.6068L41.8319 40.5068C41.8684 40.5773 41.9212 40.6381 41.986 40.684C42.0508 40.7298 42.1257 40.7594 42.2043 40.7703L44.4121 41.0844C44.5025 41.0957 44.5878 41.1325 44.6581 41.1903C44.7284 41.2482 44.7808 41.3248 44.8094 41.4112C44.8379 41.4977 44.8413 41.5905 44.8192 41.6788C44.7971 41.7672 44.7504 41.8474 44.6845 41.9103L43.0885 43.4303C43.0312 43.4845 42.9883 43.5522 42.9635 43.6271C42.9387 43.702 42.9329 43.7819 42.9466 43.8597L43.3114 45.9433C43.3263 46.0391 43.3144 46.1372 43.2769 46.2266C43.2394 46.316 43.1779 46.3933 43.0992 46.4499C43.0204 46.5064 42.9276 46.54 42.8309 46.547C42.7342 46.554 42.6374 46.534 42.5514 46.4893L40.6362 45.5038C40.5652 45.4677 40.4866 45.449 40.4069 45.449C40.3273 45.449 40.2487 45.4677 40.1777 45.5038L38.2637 46.4893C38.1775 46.5331 38.0809 46.5523 37.9845 46.5449C37.8881 46.5375 37.7955 46.5037 37.7171 46.4472C37.6386 46.3907 37.5772 46.3136 37.5395 46.2245C37.5019 46.1355 37.4895 46.0377 37.5037 45.9421L37.8685 43.8597C37.8823 43.7818 37.8764 43.7018 37.8514 43.6268C37.8264 43.5518 37.7831 43.4843 37.7254 43.4303L36.1294 41.9103C36.0635 41.8473 36.0168 41.767 35.9948 41.6786C35.9727 41.5901 35.9762 41.4973 36.0049 41.4108C36.0335 41.3242 36.0862 41.2477 36.1567 41.1899C36.2271 41.1321 36.3126 41.0955 36.403 41.0844L38.6108 40.7703C38.6893 40.7595 38.7641 40.73 38.8287 40.6841C38.8933 40.6382 38.9459 40.5774 38.9819 40.5068L39.9395 38.6068C39.9854 38.5227 40.0531 38.4526 40.1355 38.4037C40.2178 38.3549 40.3118 38.3291 40.4076 38.3291C40.5033 38.3291 40.5973 38.3549 40.6797 38.4037C40.762 38.4526 40.8297 38.5227 40.8756 38.6068Z",
    fill: "#6561FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_93665",
    x: 0.1,
    y: 14.5512,
    width: 44.734,
    height: 45.8977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_93665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_93665",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_245_93665",
    x: 6,
    y: 6.45117,
    width: 51.0332,
    height: 54.8672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_245_93665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_245_93665",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_93665",
    x1: 19.8125,
    y1: -4.62305,
    x2: 20.2,
    y2: 44.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2926AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_93665",
    x1: 19.8352,
    y1: -14.807,
    x2: 20.0546,
    y2: 12.5177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2926AA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearance);
export default __webpack_public_path__ + "static/media/Clearance.ff17249d776c4dab411b954288e273fc.svg";
export { ForwardRef as ReactComponent };